var _require = require("./calculateCart.js"),
  calculateCart = _require.calculateCart;
var _require2 = require("./storeHoursCalc.js"),
  calcOrderTimes = _require2.calcOrderTimes,
  calcStoreOpeningTimes = _require2.calcStoreOpeningTimes;
var convertPurchaseListToBackendFormat = require("./convertPurchaseListToBackendFormat.js");
var _require3 = require("./upcValidation.js"),
  isValidUpc = _require3.isValidUpc,
  validateCheckDigit = _require3.validateCheckDigit;
var packBasket = require('./packBasket.js');
var unpackBasket = require('./unpackBasket.js');
var getStoreOpenDates = function getStoreOpenDates(dates, waitTime, currentTime) {
  return calcStoreOpeningTimes(dates, waitTime, currentTime);
};
var getHoursLabels = function getHoursLabels(dayDetails, waitTime, currentTime, interval) {
  return calcOrderTimes(dayDetails, waitTime, currentTime, interval);
};
var getUnitCashPrice = function getUnitCashPrice(ccPrice, skuqty, fraction) {
  return +(+(ccPrice * skuqty) / (1 + fraction).toFixed(4)).toFixed();
};
module.exports = {
  calculateCart: calculateCart,
  convertPurchaseListToBackendFormat: convertPurchaseListToBackendFormat,
  getHoursLabels: getHoursLabels,
  getStoreOpenDates: getStoreOpenDates,
  getUnitCashPrice: getUnitCashPrice,
  isValidUpc: isValidUpc,
  packBasket: packBasket,
  unpackBasket: unpackBasket,
  validateCheckDigit: validateCheckDigit
};